import React from "react";

export const MarqueeItem = React.memo(({ item, onClick }) => (
  <div
    className="marquee-item"
    onClick={onClick}
    style={{
      color:
        item.change > 0 ? "#66FF00" : item.change < 0 ? "#FF2E4C" : "#BBBBBB",
    }}
  >
    <span className="stock-name">{item.name}</span>
    <span className="stock-price">{item.price}</span>
    <span className="stock-change">{item.change?.toFixed(2)}</span>
  </div>
));
